/* NF UX-Test (2026-09-30): schwebendes Herz „Mein Projekt“ (Merkliste) – Felix: mobil ist die Merkliste sonst
 * schwer zu finden. Nur Handy (< 768px) und nur, wenn die Merkliste Einträge hat; Zahl-Plakette, aria-label
 * „Mein Projekt (n)“. Sitzt, wo früher der Mail-Knopf war (rechts 20px, unten 150px = über dem Chat-Knopf der
 * Chat-App) und rückt über feste Leisten am unteren Rand („Weiter“-Leiste der Auswahlseite, Warenkorb-Leiste der
 * Produktseite …): unten = max(150px, Leiste + 80px), da der Chat-Knopf (60px) über solchen Leisten 10px Abstand
 * hält; über einem Hinweis (#ne-toast) 12px darüber – der Chat ist dann aus, das Herz bleibt sichtbar.
 * Ausblenden bei offenem Menü/Warenkorb/Popup und solange der Auswahl-Balken #ne-bar den Chip „n gemerkt“ zeigt
 * (sonst Stapel Balken + Chat + Herz über den +/−-Knöpfen): assets/nf-custom.css.
 *
 *  - Seiten MIT „Mein Projekt“ (Einzelfronten-Raster METOD/PAX: sections/main-collection(-pax)-configurator.liquid
 *    rendern snippets/nf-projekt-sidebar + assets/nf-projekt.js): Zahl = Merkliste dieser Seite (window.NFProjekt),
 *    Tipp öffnet das Panel (window.NFEinzel.openProjekt, assets/nf-einzel-ux.js).
 *  - alle anderen Seiten (auch die Auswahlseite ohne Raster): Merkliste aus localStorage
 *    (nf_projekt_items_<Kollektion>, Format von assets/nf-projekt.js; bei mehreren die der zuletzt genutzten
 *    Kollektion nf_projekt_last, sonst die zuletzt ergänzte), Link auf die letzte Raster-URL DIESER Kollektion
 *    (nf_projekt_last::<Kollektion>, gesetzt von assets/nf-einzel-ux.js), sonst das gemerkte Setup
 *    (nf_einzel_setup::<Kollektion>), sonst Standard + Matt – nie die ungefilterte Adresse, die zeigt die
 *    Auswahlseite ohne „Mein Projekt“. Dazu #mein-projekt → nf-einzel-ux.js öffnet dort das Panel.
 *  Aktualisierung: nf:projekt-updated (nf-einzel-ux.js nach jedem Merken/Entfernen), storage (andere Tabs),
 *  Rückkehr per Zurück/Tab-Wechsel.
 */
(function () {
  'use strict';
  if (window.NFHerz) return;

  var MQ = window.matchMedia('(max-width: 767px)');
  var PREFIX = 'nf_projekt_items_';
  var LAST = 'nf_projekt_last';
  var SETUP = 'nf_einzel_setup::';
  var BASE = 150;          // wie der frühere Mail-Knopf
  var OVER_BAR = 80;       // Chat-Knopf 60px + 10px über der Leiste + 10px Abstand
  // bekannte feste Leisten am unteren Rand; unbekannte (z. B. Cookie-Hinweis) findet barHeight() über die Bildmitte
  var BARS = ['#ne-bar', '#nf-start .nfw-foot', '.nf-mbar', '#fsmuster .fs__mbar', '#muster .mu__mbar', '.cfg-wizard__footer', '.bundle-action-buttons', '#sticky-add-to-cart'];
  var HEART = '<svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  var el = null, lastB = -1;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsKeys() { try { return Object.keys(window.localStorage); } catch (e) { return []; } }
  function readJson(k) { try { return JSON.parse(lsGet(k) || 'null'); } catch (e) { return null; } }
  function list(k) { var a = readJson(k); return Array.isArray(a) ? a : []; }
  function count(items) { return items.reduce(function (s, it) { return s + (parseInt(it && it.quantity, 10) || 0); }, 0); }
  function newest(items) { return items.reduce(function (m, it) { return Math.max(m, (it && +it.addedAt) || 0); }, 0); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function sidebar() { return document.querySelector('.nf-projekt-sidebar'); }
  function pageHandle() { var w = document.getElementById('collection-configurator'); return (w && w.dataset.collectionHandle) || ''; }

  // { n, href } – href null = Panel auf dieser Seite öffnen
  function state() {
    if (sidebar()) {
      var pj = window.NFProjekt;
      if (pj && Array.isArray(pj.items)) return { n: pj.getCount ? pj.getCount() : count(pj.items), href: null };
      var h = pageHandle();
      return { n: count(list(h ? PREFIX + h : 'nf_projekt_items')), href: null };
    }
    var last = readJson(LAST);
    var best = null;
    lsKeys().forEach(function (k) {
      if (k.indexOf(PREFIX) !== 0) return;
      var items = list(k), n = count(items);
      if (!n) return;
      var c = { h: k.slice(PREFIX.length), n: n, t: newest(items) };
      c.mine = !!(last && last.h === c.h);
      if (!best || (c.mine && !best.mine) || (c.mine === best.mine && c.t > best.t)) best = c;
    });
    if (!best) return { n: 0, href: null };
    return { n: best.n, href: urlFor(best.h, last) + '#mein-projekt' };
  }
  function okUrl(o, h) { return !!(o && o.h === h && typeof o.u === 'string' && o.u.charAt(0) === '/' && o.u.charAt(1) !== '/'); }
  function urlFor(h, last) {
    var mine = readJson(LAST + '::' + h);
    if (okUrl(mine, h)) return mine.u;
    if (okUrl(last, h)) return last.u;
    // ältere Merklisten (vor nf_projekt_last::): gemerktes Setup, sonst Standard + Matt (gibt es in METOD und PAX)
    var m = readJson(SETUP + h) || {};
    var s = m.s && m.f ? m : { s: 'Standard', f: 'Matt', c: '' };
    return root() + 'collections/' + encodeURIComponent(h) +
      '?filter.p.m.custom.filter_style=' + encodeURIComponent(s.s) + '&filter.p.m.custom.filter_surface=' + encodeURIComponent(s.f) +
      (s.c ? '&color=' + encodeURIComponent(s.c) : '');
  }

  function build(isLink) {
    var n = document.createElement(isLink ? 'a' : 'button');
    n.className = 'nf-herz';
    n.id = 'nf-herz';
    if (!isLink) n.type = 'button';
    n.innerHTML = HEART + '<span class="nf-herz__n" aria-hidden="true"></span>';
    n.addEventListener('click', function (e) {
      if (n.tagName === 'A') return;   // Link: normale Navigation
      e.preventDefault();
      if (window.NFEinzel && typeof window.NFEinzel.openProjekt === 'function') { window.NFEinzel.openProjekt(); return; }
      // Rückfall (sollte nicht vorkommen): Panel wie nf-projekt.js öffnen
      var sb = sidebar(), ov = document.querySelector('.nf-projekt-overlay');
      if (!sb) return;
      sb.classList.add('is-open');
      if (ov) ov.classList.add('is-active');
      document.body.classList.add('nf-projekt-open');
    });
    if (el && el.parentNode) el.parentNode.removeChild(el);
    el = n;
    lastB = -1;
    document.body.appendChild(n);
    return n;
  }

  function update() {
    var s = state();
    if (!s.n && !el) return;   // nichts gemerkt: gar kein Knopf im DOM
    var isLink = !!s.href;
    if (!el || (el.tagName === 'A') !== isLink) build(isLink);
    if (isLink) el.setAttribute('href', s.href); else el.removeAttribute('href');
    el.querySelector('.nf-herz__n').textContent = s.n > 99 ? '99+' : String(s.n);
    el.setAttribute('aria-label', 'Mein Projekt (' + s.n + ')');
    el.classList.toggle('is-on', s.n > 0);
    place();
  }

  // Höhe der höchsten festen Leiste, die am unteren Rand über die Breite läuft (0 = keine)
  function cover(b, vh) {
    if (!b || b.hidden || b === el) return 0;
    var cs = window.getComputedStyle(b);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return 0;
    var r = b.getBoundingClientRect();
    if (r.height <= 0 || r.width < window.innerWidth * 0.5 || r.bottom < vh - 4 || r.top >= vh) return 0;
    if (r.height > vh * 0.45) return 0;   // Panel/Overlay, keine Leiste
    return Math.ceil(vh - r.top);
  }
  function barHeight() {
    var vh = window.innerHeight, h = 0;
    BARS.forEach(function (sel) { h = Math.max(h, cover(document.querySelector(sel), vh)); });
    var e = document.elementFromPoint(window.innerWidth / 2, vh - 2);
    for (var i = 0; e && i < 15 && e !== document.body && e !== document.documentElement; i++, e = e.parentElement) {
      if (window.getComputedStyle(e).position === 'fixed') { h = Math.max(h, cover(e, vh)); break; }
    }
    return h;
  }
  // Hinweis (#ne-toast, assets/nf-einzel-ux.js) steht: Abstand seiner Oberkante zum unteren Rand, aus „bottom“ +
  // Höhe (ohne die Einblend-Verschiebung translateY, die getBoundingClientRect mitzählen würde)
  function toastHeight() {
    if (!document.documentElement.classList.contains('ne-toast-on')) return 0;
    var t = document.getElementById('ne-toast');
    if (!t || !t.offsetHeight) return 0;
    var b = parseFloat(window.getComputedStyle(t).bottom);
    var h = (isNaN(b) ? 16 : b) + t.offsetHeight;
    return h < window.innerHeight * 0.7 ? Math.ceil(h) : 0;
  }
  function place() {
    if (!el || !el.classList.contains('is-on') || !MQ.matches) return;
    var th = toastHeight();
    var b = Math.max(BASE, barHeight() + OVER_BAR, th ? th + 12 : 0);
    if (b !== lastB) { lastB = b; el.style.setProperty('--nf-herz-b', b + 'px'); }
  }
  var placeRaf = 0, placeAt = 0;
  function placeSoon() {
    if (placeRaf || !el || !el.classList.contains('is-on')) return;
    var wait = Math.max(0, 150 - (Date.now() - placeAt));
    placeRaf = setTimeout(function () { placeRaf = 0; placeAt = Date.now(); window.requestAnimationFrame(place); }, wait);
  }

  function start() {
    update();
    document.addEventListener('nf:projekt-updated', update);
    window.addEventListener('storage', function (e) { if (!e.key || e.key.indexOf(PREFIX) === 0 || e.key.indexOf(LAST) === 0) update(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) update(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') update(); });
    if (MQ.addEventListener) MQ.addEventListener('change', update); else if (MQ.addListener) MQ.addListener(update);
    window.addEventListener('scroll', placeSoon, { passive: true });
    window.addEventListener('resize', placeSoon);
    // Leisten erscheinen/verschwinden meist über Klassen an <html>/<body> (ne-bar-on, m6pn-open …)
    if (window.MutationObserver) {
      var mo = new MutationObserver(placeSoon);
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    }
    // spät eingefügte Leisten (Produktseite, Cookie-Hinweis)
    [600, 1800, 4000].forEach(function (ms) { setTimeout(placeSoon, ms); });
  }

  window.NFHerz = { update: update };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
